export default "__VITE_ASSET__rf2SEQOv__"